export { default } from '@/views/CrehanaLegal';
export { getServerSideProps } from '@/views/CrehanaLegal/server/getServerSideProps';
